var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import 'antd/lib/grid/style/index.css';
import Tooltip from 'antd/lib/tooltip';
import 'antd/lib/tooltip/style/index.css';
import SwitchRoundFlagLocked from '../../../ListRoundPage/SwitchRoundFlagLocked';
import SwitchRoundFlagFinalized from '../../../ListRoundPage/SwitchRoundFlagFinalized';
import SwitchRoundFlagVisible from '../../../ListRoundPage/SwitchRoundFlagVisible';
var selfStyles = require('../styles.scss');
var FormRound = (function (_super) {
    __extends(FormRound, _super);
    function FormRound() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormRound.prototype.render = function () {
        var round = this.props.round;
        return (React.createElement(React.Fragment, null,
            React.createElement(Tooltip, { placement: 'left', title: 'Locking scores for a round stop scores from being submitted by the judge app. You can still edit the scores on this platform.' },
                React.createElement(Row, { style: { paddingBottom: '8px' } },
                    React.createElement(Col, { xs: 12, className: selfStyles.formRoundTextWrapper },
                        React.createElement("h4", { className: selfStyles.formRoundText }, "Lock Round")),
                    React.createElement(Col, { xs: 12 },
                        React.createElement(SwitchRoundFlagLocked, { round: round, handlePatchRound: this.props.handlePatchRound })))),
            React.createElement(Tooltip, { placement: 'left', title: 'Confirming scores for a round adds a label to the scoreboard to let your athletes and spectators know that the scores have been verified by the Chief Judge' },
                React.createElement(Row, { style: { paddingBottom: '8px' } },
                    React.createElement(Col, { xs: 12, className: selfStyles.formRoundTextWrapper },
                        React.createElement("h4", { className: selfStyles.formRoundText }, "Confirm Scores")),
                    React.createElement(Col, { xs: 12 },
                        React.createElement(SwitchRoundFlagFinalized, { round: round, handlePatchRound: this.props.handlePatchRound })))),
            React.createElement(Tooltip, { placement: 'left', title: 'Publishing scores for a round allows athletes and spectators to see the scores and its live updates' },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12, className: selfStyles.formRoundTextWrapper },
                        React.createElement("h4", { className: selfStyles.formRoundText }, "Publish Scores")),
                    React.createElement(Col, { xs: 12 },
                        React.createElement(SwitchRoundFlagVisible, { round: round, handlePatchRound: this.props.handlePatchRound }))))));
    };
    return FormRound;
}(React.Component));
export default FormRound;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/DashboardForm/DashboardFormRound/FormRound.tsx
// module id = 972
// module chunks = 0